import { useState } from "react";
import { createDocument } from "../services/documentService"; // Import API function
import "bootstrap/dist/css/bootstrap.min.css";

export default function DocumentCreation() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [message, setMessage] = useState("");
  const token = localStorage.getItem("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !content) {
      setMessage("Both title and content are required.");
      return;
    }

    try {
      await createDocument(title, content, token);
      setMessage("Document successfully created!");
      setTitle("");
      setContent("");
    } catch (error) {
      setMessage("Failed to create document. Please try again.");
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Document Aanmaken (werkt nog niet)</h2>
      {message && (
        <div className={`alert ${message.includes("successfully") ? "alert-success" : "alert-danger"}`}>
          {message}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Content</label>
          <textarea
            className="form-control"
            rows="5"
            value={content}
            onChange={(e) => setContent(e.target.value)}
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary">Create Document</button>
      </form>
    </div>
  );
}
